export default __webpack_public_path__ + "locales/lo-LA/Payments.json?hash=d478c70bb16c5971ad62e3aff6200a4b";